<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('nav.spot-check') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.spot-check') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<div class="pull-right">
								<!--<el-date-picker
							      v-model="dateRange"
							      type="daterange"
							      value-format="yyyy-MM-dd"
							      ref="dateRange">
							    </el-date-picker>-->
							</div>
							<h4>
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel"></el-button>
								</el-tooltip>
								<el-tooltip :content="$t('dashboard.refresh')" placement="top">
									<el-button type="text" class="el-icon-refresh" @click="refreshData"></el-button>
								</el-tooltip>
							</h4>
						</div>
						<div class="card-body">
						  <el-table
							id="sc-spot"
						    ref="spot-check"
						    :data="data"
						    style="width: 100%"
						    >
						    <el-table-column
						      prop="name"
						      :label="$t('dashboard.behavior-audit.user')"
						      width="130"
						      align="center"
						      sortable
						      fixed>
						    </el-table-column>
						    <el-table-column
						      prop="team"
						      :label="$t('dashboard.behavior-audit.team')"
						      width="140"
						      align="center"
						      sortable
						      :filters="teamFilters"
      						  :filter-method="filterTeam"
						      >
						      <template slot-scope="scope">
						        {{ getTeam(scope.row.team) }}
						      </template>
						    </el-table-column>
						    <el-table-column
						      prop="practiceId"
						      :label="$t('dashboard.behavior-audit.practice')"
						      width="140"
						      align="center"
						      sortable
						      :filters="practiceFilters"
      						  :filter-method="filterPractice"
						      >
						      <template slot-scope="scope">
						        {{ getPractice(scope.row.practiceId) }}
						      </template>
						    </el-table-column>
						    <el-table-column
						      prop="comment"
						      :label="$t('dashboard.behavior-audit.comment')"
						      align="center"
						      width="200"
						      >
						      <template slot-scope="scope">
					        	<div v-for="c in scope.row.comment">
						        	<el-link type="info" :href="url + c[3]" target="_blank">
						        		{{ c[4] }} : {{ c[1] }} Operating Time: {{ c[2] }}
						        	</el-link>
					        	</div>
					          </template>
						    </el-table-column>
						    <el-table-column
						      prop="lr"
						      :label="$t('dashboard.behavior-audit.lr')"
						      align="center"
						      width="200"
						      >
						      <template slot-scope="scope">
					        	<div v-for="c in scope.row.lr">
						        	<el-link type="info" :href="url + c[1]" target="_blank">
						        		{{ c[2] }} : {{ c[0] }} Operating Time: {{ c[3] }}
						        	</el-link>
					        	</div>
					          </template>
						    </el-table-column>
						    <el-table-column
						      prop="salary"
						      :label="$t('dashboard.behavior-audit.salary')"
						      align="center"
						      width="200"
						      >
						      <template slot-scope="scope">
					        	<div v-for="c in scope.row.salary">
						        	<el-link type="info" :href="url + c[1]" target="_blank">
						        		{{ c[2] }} : {{ c[0] }} Operating Time: {{ c[3] }}
						        	</el-link>
					        	</div>
					          </template>
						    </el-table-column>
						   </el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
<script>
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'SC-Spot',
  data: function() {
	return {
	  data: null
	}
  },
  computed: {
    url: function() {
      return this.STARLINKS_URL + 'people/'
    },
    teamFilters: function() {
	  let filter = this.team,
	      that = this
	  filter.forEach(function(v) {
	    v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
	    v.value = v.id
	  })
	  return filter
	},
	practiceFilters: function() {
	  let filter = this.practice,
	      that = this
	  filter.forEach(function(v) {
	    v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
	    v.value = v.id
	  })
	  return filter
	}
  },
  watch: {
  },
  methods: {
    refreshData: function() {
      this.loadData()
    },
    filterTeam: function(value, row) {
      return row.team === value
    },
    filterPractice: function(value, row) {
      return row.practice === value
    },
    exportExcel () {
  	  let wb = XLSX.utils.table_to_book(document.querySelector('#sc-spot'))
  	  /* get binary string as output */
  	  let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
  	  try {
  	    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-Spot-Check.xlsx')
  	  } catch (e) {
  	    if (typeof console !== 'undefined')
  	      console.log(e, wbout)
  	  }
  	  return wbout
    },
    loadData: function() {
      let query = '?userId=' + localStorage.getItem('token'),
          that = this,
          loading = Loading.service({ fullscreen: true })
	  this.$http.get(this.API3_PREFIX + 'sc_audit' + query).then(function (response) {
		that.data = response.data
		that.$nextTick(() => {
          loading.close()
        })
      }).catch(function (error) {
		console.log(error)
		that.$nextTick(() => {
          loading.close()
        })
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>